/* @jsxImportSource react */

import type { PropsWithChildren } from 'react';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { sharedTileButtonClass } from './shared';

export type TileButtonProps = PropsWithChildren & {
  /* 
    is the tile an active tile
  */
  mode: 'selected' | 'disabled' | 'disabledAndSelected';
};
/* 
  The TileButton component is a common Button but is extended with loading indicator
  which is visible while the new variation is loading its data
*/
export const TileButton = ({ mode, children }: TileButtonProps) => {
  switch (mode) {
    case 'disabled':
    case 'disabledAndSelected': {
      return (
        <Button
          disabled
          size="large"
          className={`text-color-text-darktransparent bg-color-background-base border-dashed line-through opacity-100! ${mode === 'disabledAndSelected' ? 'border-color-text-dark border-2' : 'border-color-grey'} ${sharedTileButtonClass}`}
        >
          {children}
        </Button>
      );
    }
    case 'selected':
    default:
      return (
        <Button
          disabled
          size="large"
          className={`text-color-text-dark border-color-text-dark outline-color-text-dark opacity-100! outline-[3px]! -outline-offset-[2px] outline-solid! ${sharedTileButtonClass}`}
        >
          {children}
        </Button>
      );
  }
};
